import {CONTRACTOR_INSURANCES_REQUEST, CONTRACTOR_INSURANCES_SUCCESS, CONTRACTOR_INSURANCES_FAILURE} from '../actions';
import {STORE_CONTRACTOR_INSURANCE_REQUEST, STORE_CONTRACTOR_INSURANCE_SUCCESS, STORE_CONTRACTOR_INSURANCE_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_INSURANCE_REQUEST, UPDATE_CONTRACTOR_INSURANCE_SUCCESS, UPDATE_CONTRACTOR_INSURANCE_FAILURE} from '../actions';
import {
    INSURANCE_DOCUMENT_UPLOAD_REQUEST,
    INSURANCE_DOCUMENT_UPLOAD_SUCCESS,
    INSURANCE_DOCUMENT_UPLOAD_FAILURE,
    INSURANCE_DOCUMENT_DELETE_REQUEST,
    INSURANCE_DOCUMENT_DELETE_SUCCESS,
    INSURANCE_DOCUMENT_DELETE_FAILURE
} from '../actions';
import insuranceReducer from './contractor-insurance';

export const CONTRACTOR_INSURANCES_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null
};

const updateInsurance = (state, action) => {
    let {data} = state;
    const {id} = action;
    const insurance = data.find(b => b.id === id);
    data.splice(data.indexOf(insurance), 1);
    const reduced = insuranceReducer(insurance, action);
    data = [...state.data, reduced];

    return {...state, data};
};

const insurancesReducers = {
    [CONTRACTOR_INSURANCES_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_INSURANCES_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_INSURANCES_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_CONTRACTOR_INSURANCE_REQUEST]: (state, action) => {
        const insurance = insuranceReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), insurance];

        return {...state, data};
    },
    [STORE_CONTRACTOR_INSURANCE_SUCCESS]: (state, action) => {
        let {data} = state;
        const insurance = data.find(b => b.draft);
        data.splice(data.indexOf(insurance), 1);
        const reduced = insuranceReducer(insurance, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_CONTRACTOR_INSURANCE_FAILURE]: (state, action) => {
        let {data} = state;
        const insurance = data.find(b => b.draft);
        data.splice(data.indexOf(insurance), 1);
        const reduced = insuranceReducer(insurance, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_CONTRACTOR_INSURANCE_REQUEST]: updateInsurance,
    [UPDATE_CONTRACTOR_INSURANCE_SUCCESS]: updateInsurance,
    [UPDATE_CONTRACTOR_INSURANCE_FAILURE]: updateInsurance,
    [INSURANCE_DOCUMENT_UPLOAD_REQUEST]: updateInsurance,
    [INSURANCE_DOCUMENT_UPLOAD_SUCCESS]: updateInsurance,
    [INSURANCE_DOCUMENT_UPLOAD_FAILURE]: updateInsurance,
    [INSURANCE_DOCUMENT_DELETE_REQUEST]: updateInsurance,
    [INSURANCE_DOCUMENT_DELETE_SUCCESS]: updateInsurance,
    [INSURANCE_DOCUMENT_DELETE_FAILURE]: updateInsurance
};

export default function insurances(state = CONTRACTOR_INSURANCES_INITIAL_STATE, action) {
    let reducer = insurancesReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-insurances.js